import { render, staticRenderFns } from "./MANUAL_phone.vue?vue&type=template&id=5fa6c20d&scoped=true"
import script from "./MANUAL_phone.vue?vue&type=script&lang=js"
export * from "./MANUAL_phone.vue?vue&type=script&lang=js"
import style0 from "./MANUAL_phone.vue?vue&type=style&index=0&id=5fa6c20d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6c20d",
  null
  
)

export default component.exports